import { render, staticRenderFns } from "./SoftDetails.vue?vue&type=template&id=ae2cf762&scoped=true&"
import script from "./SoftDetails.vue?vue&type=script&lang=js&"
export * from "./SoftDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoftDetails.vue?vue&type=style&index=0&id=ae2cf762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2cf762",
  null
  
)

export default component.exports